module.exports = __webpack_public_path__ + "media/customizations/windler/logo-new-3de3ffbe55c0f87daa31effd8637e6bd.png";